import React from 'react'
import clsx from 'clsx'
import NextImage from 'next/image'

import { Text } from '@wartek-id/text-v1'

import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'
import { SimpleCard } from 'app/KinerjaPSPegawaiPage/components/SimpleCard'
import {
  PERENCANAAN_STEPS_TIM_KINERJA,
  PERENCANAAN_STEPS_PEJABAT_PENILAI_KINERJA,
} from 'app/KinerjaTimPenilaiPSPage/constants/perencanaan'

export default function Steps() {
  const { isTimKinerjaPengawasSekolah, isPPKPengawasSekolah } = useRoleContext()

  const steps = React.useMemo(() => {
    if (isTimKinerjaPengawasSekolah) {
      return PERENCANAAN_STEPS_TIM_KINERJA
    }

    if (isPPKPengawasSekolah) {
      return PERENCANAAN_STEPS_PEJABAT_PENILAI_KINERJA
    }

    return []
  }, [isPPKPengawasSekolah, isTimKinerjaPengawasSekolah])

  return (
    <div
      className={clsx(
        'grid gap-2',
        isPPKPengawasSekolah && 'grid-cols-3',
        isTimKinerjaPengawasSekolah && 'grid-cols-2'
      )}
    >
      {steps.map(({ title, subtitle, icon }, index) => (
        <SimpleCard
          key={`tahapan-perencanaan-${index}`}
          data-testid="tahapan-perencanaan-card"
          className="flex items-center w-full col-span-1 p-6 space-x-4 border-0 rounded-none"
        >
          <div className="flex items-center justify-center flex-none w-6 h-6 rounded-full bg-icon-default">
            <Text variant="body-sm" color="inverse">
              {index + 1}
            </Text>
          </div>

          <div>
            <NextImage
              src={`/illustrations/${icon}.png`}
              width="60px"
              height="60px"
            />
          </div>

          <div className="space-y-1">
            <Text variant="heading-sm">{title}</Text>
            <Text color="subdued">{subtitle}</Text>
          </div>
        </SimpleCard>
      ))}
    </div>
  )
}
